import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { Dialog, FlatButton } from 'material-ui'
import { setSnackbarMessage } from '../../../../actions/snackbar'
import api from '../../../../api'

class VoidTransactionDialog extends Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      open: false,
      dialogTitle: `${props.isVoid ? 'Revalidate' : 'Void'} ${this.props.transactionLabel}`,
      dialogMessage: `Are you sure you want to ${this.props.isVoid ? 'revalidate' : 'void'} this ${this.props.transactionLabel}?`,
      isErrorDialog: false
    }
  }

  handleActionConfirm () {
    api
      .patch(`admin/${this.props.transactionLabel}s/${this.props.transaction.id}/${this.props.isVoid ? 'revalidate' : 'void'}`)
      .then(res => {
        res.json().then(data => {
          if (res.ok) {
            if (this.props.transactionLabel === 'refund') {
              this.props.onRefundUpdated()
            } else {
              this.props.onPaymentUpdated()
            }
            this.props.onSnackbarMessage(`Successfully ${this.props.isVoid ? 'revalidated' : 'voided'} #${data.id}`)
            this.props.closeDialog()
          } else {
            this.setState({
              dialogTitle: 'Error',
              dialogMessage: data.message,
              isErrorDialog: true
            })
          }
        })
      })
  }

  handleVoidCancel () {
    this.props.closeDialog()
  }

  handleError () {
    this.props.closeDialog()
    this.setState({
      dialogTitle: `${this.props.isVoid ? 'Revalidate' : 'Void'} ${this.props.transactionLabel}`,
      dialogMessage: `Are you sure you want to ${this.props.isVoid ? 'Revalidate' : 'Void'} this ${this.props.transactionLabel}?`,
      isErrorDialog: false
    })
  }

  render () {
    const { open, isVoid } = this.props

    const renewActions = [
      <FlatButton
        label='Cancel'
        primary
        onClick={this.handleVoidCancel.bind(this)}
      />,
      <FlatButton
        label={isVoid ? 'Revalidate' : 'Void'}
        primary
        keyboardFocused
        onClick={this.handleActionConfirm.bind(this)}
      />
    ]

    const errorActions = [
      <FlatButton
        label='ok'
        primary
        onClick={this.handleError.bind(this)}
      />
    ]

    return (
      <Dialog
        modal={false}
        open={open}
        title={this.state.dialogTitle}
        onCancel={this.props.closeDialog}
        actions={this.state.isErrorDialog ? errorActions : renewActions}
      >
        {this.state.dialogMessage}
      </Dialog>
    )
  }
}

// @ts-ignore
VoidTransactionDialog.propTypes = {
  onSnackbarMessage: PropTypes.func.isRequired
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = (dispatch) => ({
  onSnackbarMessage: (msg) => {
    dispatch(setSnackbarMessage(msg))
  }
})

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(VoidTransactionDialog)
